import { html } from 'lit';

export const comsText1Template = (
  node: HTMLElement,
) => html`<em>${node.innerHTML}</em>`;

export const comsText2Template = (
  node: HTMLElement,
) => html`<strong><em>${node.innerHTML}</em></strong>`;

export const comsText3Template = (
  node: HTMLElement,
) => html`<one-text spaced>${node.innerHTML}</one-text>`;
